module.exports = __webpack_public_path__ + "static/scale-model-of-old-fort-erie-in-buffalo-new-york-01ab62e6074130a9a2b4a954c51ce9b7.png";